var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.video),function(vd,key){return _c('div',{key:key},[_c('video',{staticClass:"app-video",attrs:{"src":_vm.$pathFilesSystem+'/'+vd.url,"controls":"","autoplay":"","loop":"","muted":""},domProps:{"muted":true}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }